import Icon from "@ant-design/icons/lib/icons/OpenAIFilled";
import type {EditorIconProps} from "../icons";
export default function OpenAI({style, className}: EditorIconProps) { return <Icon style={style} className={className}/>; }
